import { createSlice } from '@reduxjs/toolkit';

import axios from 'axios';
import { dispatch } from '../index';

const initialState = {
    error: null,
    personaList: [],
    personaListUpdate: false
};

// ==============================|| SLICE - CAMPAIGN DETAIL ||============================== //

const slice = createSlice({
    name: 'persona',
    initialState,
    reducers: {
        hasError(state, action) {
            if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'login'
            } else {
                state.error = action.payload.response.data;
            }
        },
        setPersonaListUpdate(state, action) {
            state.personaListUpdate = !state.personaListUpdate;
        },
        setPersonaList(state, action) {
            state.personaList = action.payload.personaList;
            state.personaListUpdate = false;
        },
        setPersona(state, action) {
            if(state.personaList.filter(p => p.name == action.payload.persona.name).length == 0) {
                state.personaList.push(action.payload.persona);
            }
        },
        removePersona(state, action) {
            state.personaList = state.personaList.filter(p => p.id != action.payload)
        },
    }
});

export default slice.reducer;

export function getPersonaList(data, callback) {
    return async () => {
        dispatch(slice.actions.setPersonaListUpdate());
        try {
            const response = await axios.post('/api/persona/list', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setPersonaList(response.data));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function createPersona(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/persona/create', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setPersona(response.data));
            if (callback) {
                callback(response.data);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function removePersona(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/persona/remove', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.removePersona(data.id));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}